import { observer } from "mobx-react-lite";
import PageHeader from './header';
import PageInprogress from './inprogress';
import PageInto from './intro';
import PageToChoose from './toChoose';

const XTLaunchpadPage = () => {

  return (
    <div className="bg-[#fff] min-w-[1200px] sm:w-full sm:min-w-0">
      <PageHeader />
      <div className="pb-[80px] w-[1200px] sm:w-full sm:min-w-0 mx-auto sm:p-[22px]">
        <PageInprogress />
        <PageInto />
        <PageToChoose />
      </div>
    </div>
  );
};

export default observer(XTLaunchpadPage);